// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__About from "./About/About.js";
import * as Buhta_landing__BlogHomePage from "../Blog/Home/BlogHomePage.js";
import * as Buhta_landing__BlogPostPage from "../Blog/Post/BlogPostPage.js";
import * as Buhta_landing__ClassifiersPage from "./Classifiers/ClassifiersPage.js";
import * as Buhta_landing__Clients from "./Clients/Clients.js";
import * as Buhta_landing__ESF from "./ESF/ESF.js";
import * as Buhta_landing__FAQPage from "./FAQ/FAQPage.js";
import * as Buhta_landing__Features from "./Features/Features.js";
import * as Buhta_landing__Finance from "./Finance/Finance.js";
import * as Buhta_landing__Footer from "./Footer/Footer.js";
import * as Buhta_landing__Jumbo from "./Home/Jumbo.js";
import * as Buhta_landing__Kassa from "./Kassa/Kassa.js";
import * as Buhta_landing__LegalAgreementPage from "./Legal/LegalAgreementPage.js";
import * as Buhta_landing__LegalConsentPage from "./Legal/LegalConsentPage.js";
import * as Buhta_landing__LegalPrivacyPage from "./Legal/LegalPrivacyPage.js";
import * as Buhta_landing__LegalSecurityPage from "./Legal/LegalSecurityPage.js";
import * as Buhta_landing__LibraryArticlePage from "../Library/Article/LibraryArticlePage.js";
import * as Buhta_landing__LibraryHomePage from "../Library/LibraryHomePage.js";
import * as Buhta_landing__Navbar from "./Navbar/Navbar.js";
import * as Buhta_landing__Outsourcing from "./Outsourcing/Outsourcing.js";
import * as Buhta_landing__Payroll from "./Payroll/Payroll.js";
import * as Buhta_landing__Route from "../../Route.js";
import * as Buhta_landing__TaxReporting from "./TaxReporting/TaxReporting.js";
import * as Buhta_landing__Tis from "./Tis/Tis.js";
import * as Buhta_models__Locale from "../../../../../packages/models/Locale.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function Site(Props) {
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  const language = Buhta_models__Locale.toString(Buhta_landing__Route.getLanguage(undefined));
  const match = React.useState(function () {
    return false;
  });
  const setBodyFixed = match[1];
  const homepage = Belt__Belt_List.toArray({
    hd: JsxRuntime.jsx(Buhta_landing__Jumbo.make, {
      setBodyFixed: setBodyFixed
    }, "jumbo"),
    tl: {
      hd: JsxRuntime.jsx(Buhta_landing__Features.make, {}, "features"),
      tl: {
        hd: JsxRuntime.jsx(Buhta_landing__Clients.make, {}, "clients"),
        tl: /* [] */ 0
      }
    }
  });
  let navbarTheme;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Landing */ 0) {
    navbarTheme = "light";
  } else {
    let tmp = currentRoute._2;
    if (/* tag */ typeof tmp === "number" || typeof tmp === "string") {
      switch (tmp) {
        case /* Kassa */ 13 :
        case /* Payroll */ 16 :
          navbarTheme = "dark";
          break;
        case /* Finance */ 17 :
          navbarTheme = "gray";
          break;
        default:
          navbarTheme = "light";
      }
    } else {
      navbarTheme = tmp.TAG === /* Classifiers */ 8 ? "dark" : "light";
    }
  }
  let tmp$1;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Landing */ 0) {
    tmp$1 = homepage;
  } else {
    const landing = currentRoute._2;
    if (/* tag */ typeof landing === "number" || typeof landing === "string") {
      switch (landing) {
        case /* Home */ 0 :
          tmp$1 = homepage;
          break;
        case /* Tis */ 1 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Tis.make, {});
          break;
        case /* Outsourcing */ 2 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Outsourcing.make, {});
          break;
        case /* Kassa */ 13 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Kassa.make, {});
          break;
        case /* TaxReporting */ 14 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__TaxReporting.make, {});
          break;
        case /* ESF */ 15 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__ESF.make, {});
          break;
        case /* Payroll */ 16 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Payroll.make, {});
          break;
        case /* Finance */ 17 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Finance.make, {});
          break;
        case /* FAQ */ 18 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__FAQPage.make, {});
          break;
        default:
          tmp$1 = JsxRuntime.jsx(Buhta_landing__About.make, {});
      }
    } else {
      switch (landing.TAG) {
        case /* Blog */ 1 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__BlogHomePage.make, {
            pageNum: landing._0,
            language: language
          });
          break;
        case /* BlogPost */ 2 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__BlogPostPage.make, {
            slug: landing._0,
            language: language
          });
          break;
        case /* BlogSection */ 3 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__BlogHomePage.make, {
            pageNum: landing._1,
            slug: landing._0,
            language: language
          });
          break;
        case /* Library */ 4 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__LibraryHomePage.make, {
            pageNum: landing._0,
            language: language
          });
          break;
        case /* LibrarySection */ 5 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__LibraryHomePage.make, {
            pageNum: landing._1,
            slug: landing._0,
            language: language
          });
          break;
        case /* LibraryArticle */ 6 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__LibraryArticlePage.make, {
            slug: landing._0,
            language: language
          });
          break;
        case /* Legal */ 7 :
          switch (landing._0) {
            case /* Privacy */ 0 :
              tmp$1 = JsxRuntime.jsx(Buhta_landing__LegalPrivacyPage.make, {});
              break;
            case /* Agreement */ 1 :
              tmp$1 = JsxRuntime.jsx(Buhta_landing__LegalAgreementPage.make, {});
              break;
            case /* Consent */ 2 :
              tmp$1 = JsxRuntime.jsx(Buhta_landing__LegalConsentPage.make, {});
              break;
            case /* Security */ 3 :
              tmp$1 = JsxRuntime.jsx(Buhta_landing__LegalSecurityPage.make, {});
              break;
          }
          break;
        case /* Classifiers */ 8 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__ClassifiersPage.make, {});
          break;
        default:
          tmp$1 = JsxRuntime.jsx(Buhta_landing__About.make, {});
      }
    }
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Buhta_landing__Navbar.make, {
        theme: navbarTheme,
        setBodyFixed: setBodyFixed
      }),
      tmp$1,
      JsxRuntime.jsx(Buhta_landing__Footer.make, {})
    ],
    className: Cn.fromList({
      hd: "font-haas",
      tl: {
        hd: match[0] ? "h-80vh overflow-hidden" : "",
        tl: /* [] */ 0
      }
    })
  });
}

const make = Site;

export {
  make,
}
/* Buhta_landing__About Not a pure module */
